<script setup>
const { application, className = "" } = defineProps({
  application: Object,
  className: String,
});

const statusColor = computed(() => {
  return getStatusColorCode(application?.status);
});

const applicationStatus = computed(() => {
  return getApplicationStatus(application?.status);
});
</script>

<template>
  <p class="flex gap-2 py-2 items-center text-sm font-medium">
    <span
      class="relative size-5 rounded-full border flex items-center justify-center"
      :style="{ borderColor: statusColor }"
    >
      <i class="pi pi-circle-fill text-md" :style="{ color: statusColor }"></i>
    </span>
    <span :class="className">{{ applicationStatus }}</span>
  </p>
</template>
